"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenIdentifierValue = exports.TokenIdentifierType = void 0;
const types_1 = require("./types");
const EGLDTokenIdentifier = "EGLD";
class TokenIdentifierType extends types_1.PrimitiveType {
    constructor() {
        super("TokenIdentifier");
    }
    getClassName() {
        return TokenIdentifierType.ClassName;
    }
}
exports.TokenIdentifierType = TokenIdentifierType;
TokenIdentifierType.ClassName = "TokenIdentifierType";
class TokenIdentifierValue extends types_1.PrimitiveValue {
    constructor(value) {
        super(new TokenIdentifierType());
        this.value = value;
    }
    static egld() {
        return new TokenIdentifierValue(EGLDTokenIdentifier);
    }
    static esdtTokenIdentifier(identifier) {
        return new TokenIdentifierValue(identifier);
    }
    getClassName() {
        return TokenIdentifierValue.ClassName;
    }
    getLength() {
        return this.value.length;
    }
    /**
     * Returns whether two objects have the same value.
     */
    equals(other) {
        if (this.getLength() != other.getLength()) {
            return false;
        }
        return this.value == other.value;
    }
    valueOf() {
        return this.value;
    }
    toString() {
        return this.value.toString();
    }
}
exports.TokenIdentifierValue = TokenIdentifierValue;
TokenIdentifierValue.ClassName = "TokenIdentifierValue";
//# sourceMappingURL=tokenIdentifier.js.map